module.exports = __webpack_public_path__ + "static/sound-illustration-70b4c92e9842c3f3154b2a24674fff61.jpg";